module.exports = __webpack_public_path__ + "02_veryshort_brown.58def494.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_veryshort_brown.png
// module id = RCKp
// module chunks = 0